import React from 'react';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './CommissionPointsAndPrice.scss';
const CommissionPointsAndPrice = ({ points , price  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, points && /*#__PURE__*/ React.createElement("div", {
        className: s['points-value']
    }, /*#__PURE__*/ React.createElement(PointsIcon, {
        className: s['points-icon'],
        size: IconSize.SMALLER
    }), points), /*#__PURE__*/ React.createElement("div", {
        className: s['dollars-cost']
    }, price));
};
CommissionPointsAndPrice.displayName = 'CommissionPointsAndPrice';
export default CommissionPointsAndPrice;
